import { Container, ThemeProvider, Button, Typography } from "@mui/material";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { AppContext } from "AppContext";
import { API, graphqlOperation } from "aws-amplify";
import React, { useEffect, useState } from "react";
import CreateOrUpdateAddDialog from "../components/CreateOrUpdateAddDialog";
import JobRequestCard from "../components/JobRequestCard";
import JobRequestCommentCard from "../components/JobRequestCommentCard";
import SubscriptionCard from "../components/SubscriptionCard";
import theme from "../components/mainTheme";
import Notification from "../components/Notification";
import {
  getAllInterestsByUser,
  getMyAnnonser,
  getNotificationsByUser,
} from "../customgraphql/queries";
import { createJobRequest, updateJobRequest } from "../graphql/mutations";
//import { listNotifications } from "../graphql/queries";
import { ROUTES } from "../Routes";
import CreateSubscriptionDialog from "../components/CreateSubscriptionDialog";
//import getSubscriptionsbyUser from "utils/getSubscriptionsbyUser";
import NotificationAddIcon from "@mui/icons-material/NotificationAdd";

export default function MyPage() {
  const appContext = React.useContext(AppContext);
  const isLoggedOn = appContext.authenticated === true;

  const [currentUser, setCurrentUser] = useState(null);
  const [myJobs, setMyJobs] = useState([]);
  const [myComments, setMyComments] = useState([]);
  const [showtab, setShowtab] = useState("annonser");
  const [mySubscriptions, setMySubscriptions] = useState([]);

  const [
    showCreateOrUpdateAdDialog,
    setShowCreateOrUpdateAdDialog,
  ] = React.useState(false);
  const [showCreateSubscription, setShowCreateSubscription] = React.useState(
    false
  );
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  // const user = useUserProfile();
  useEffect(() => {
    fetchUserandData(appContext.userProfile);
  }, []);

  useEffect(() => {
    const check = () => {
      if (window.location.href.indexOf("createNewAd") > -1 && isLoggedOn) {
        if (!appContext.userProfile) {
          alert("Du måste fylla i ditt konto");
        } else {
          setShowCreateOrUpdateAdDialog(true);
        }
      }
    };
    check();
    window.addEventListener("hashchange", check);

    function cleanup() {
      window.removeEventListener("hashchange", check);
    }
    return cleanup;
  }, []);

  const getAddsByUser = async (user) => {
    const promise = API.graphql(graphqlOperation(getMyAnnonser, user));
    promise.catch((asdf) => {});
    promise.then((apiData) => {
      const jobs = apiData.data.listJobRequests.items;
      jobs.sort(function (job1, job2) {
        if (job1.startDate > job2.startDate) {
          return 1;
        }
        if (job1.startDate === job2.startDate) {
          return 0;
        }
        return -1;
      });
      setMyJobs(jobs);
    });
  };

  const updateAdFunc = async (job, id, closeDialog) => {
    if (id) {
      // Update the ad
      job.id = id;
      const promise = API.graphql(
        graphqlOperation(updateJobRequest, { input: job })
      );
      promise.then(function () {
        setNotify({
          isOpen: true,
          message: "Din Annons är uppdaterad!",
          type: "success",
        });

        getAddsByUser({ userId: currentUser.id });
        closeDialog();
      });
    } else {
      const promise = API.graphql(
        graphqlOperation(createJobRequest, { input: job })
      );
      promise.then(() => {
        setNotify({
          isOpen: true,
          message: "Din annons har postats!",
          type: "success",
        });

        getAddsByUser({ userId: currentUser.id });
        closeDialog();
      });
      promise.catch((error) => {
        setNotify({
          isOpen: true,
          message: "Någonting gick fel! Testa gärna igen.",
          severity: "error",
        });
        closeDialog();
      });
    }
  };

  async function fetchUserandData(user) {
    //console.log("User is", user);
    if (!user) {
      return;
    }
    setCurrentUser(user);
    getAddsByUser({ userId: user.id });
    getInterestsByUser({ userId: user.id });
    getSubscriptionsByUser({ userId: user.id });
  }
  // getting users interests
  async function getInterestsByUser(user) {
    const p = API.graphql(graphqlOperation(getAllInterestsByUser, user));
    p.then((apiData) => {
      setMyComments(apiData.data.listJobRequestComments.items);
    });
  }
  // getting users subscriptions.
  async function getSubscriptionsByUser(user) {
    const p = API.graphql(graphqlOperation(getNotificationsByUser, user));
    p.then((apiData) => {
      setMySubscriptions(apiData.data.listNotifications.items);
    });
    p.catch((err) => console.error("Error in getSubscriptionsByUser", err));
  }

  const closeDialog = () => {
    setShowCreateOrUpdateAdDialog(false);
    setShowCreateSubscription(false);
    function f() {
      window.location = ROUTES.MY_JOB_REQUESTS;
    }
    setTimeout(f, 2000);
  };

  const closeSubscriptionDialogAfterCreate = () => {
    setShowCreateSubscription(false);
    setShowtab("subscriptions");
    setNotify({
      isOpen: true,
      message: "Din bevakning har skapats!",
      type: "success",
    });
  };
  const closeSubscriptionDialog = () => {
    setShowCreateSubscription(false);
  };

  const noJobs = showtab === "annonser" && myJobs && myJobs.length === 0;
  const noMessage =
    showtab === "interests" && myComments && myComments.length === 0;
  const noSubscriptions =
    showtab === "subscriptions" &&
    mySubscriptions &&
    mySubscriptions.length === 0;
  return (
    <>
      <Container maxWidth="md">
        <Typography
          variant="h4"
          sx={{ pt: 2, fontSize: "28px", fontWeight: "600", mb: 0 }}
          component="div"
          gutterBottom
        >
          MIN SIDA
          <Button
            sx={{ ml: 2, mb: 0.5 }}
            variant="outlined"
            size="small"
            endIcon={<NotificationAddIcon />}
            onClick={() => setShowCreateSubscription(true)}
          >
            Skapa Bevakning
          </Button>
        </Typography>
        <Notification notify={notify} setNotify={setNotify} />
        {showCreateOrUpdateAdDialog && (
          <CreateOrUpdateAddDialog
            isOpen={true}
            closeDialog={closeDialog}
            updateAdFunc={updateAdFunc}
          />
        )}
        {showCreateSubscription && (
          <CreateSubscriptionDialog
            isOpen={true}
            closeDialog={closeSubscriptionDialog}
            closeAfterCreate={closeSubscriptionDialogAfterCreate}
            refreshFunc={getSubscriptionsByUser}
          />
        )}

        <StatusTabs
          value={showtab}
          onChange={(value) => {
            setShowtab(value);
          }}
        />

        {showtab === "interests" &&
          myComments &&
          myComments.map((comment) => {
            return (
              <JobRequestCommentCard
                key={comment.id}
                comment={comment}
                getInterestsByUser={getInterestsByUser}
              />
            );
          })}

        {showtab === "subscriptions" &&
          mySubscriptions &&
          mySubscriptions.map((sub) => {
            return (
              <SubscriptionCard
                key={sub.id}
                subscription={sub}
                getSubscriptionsByUser={getSubscriptionsByUser}
              />
            );
          })}

        {noJobs && <h2>Du har inte några annonser</h2>}
        {noMessage && <h2> Du har inte några meddelanden</h2>}
        {noSubscriptions && <h2> Du har inte några bevakningar</h2>}
        {showtab === "annonser" &&
          myJobs &&
          myJobs.map((job) => {
            return (
              <JobRequestCard
                job={job}
                key={job.id}
                admin={true}
                getAddsByUser={getAddsByUser}
                updateAdFunc={updateAdFunc}
              />
            );
          })}
      </Container>
    </>
  );
}

/*
async function getInterestsByUser(user) {
  const p = await API.graphql(graphqlOperation(getAllInterestsByUser, user));
  const items = p.data.listJobRequestComments.items;
  return items;
}
*/

function StatusTabs(props) {
  const value = props.value;
  const onChange = props.onChange || (() => {});

  return (
    <ThemeProvider theme={theme}>
      <Tabs
        value={value}
        style={{
          flex: "1",
          justifyContent: "center",
        }}
        onChange={(event, newValue) => {
          onChange(newValue);
        }}
      >
        <Tab label="Annonser" value="annonser" />
        <Tab label="Meddelanden" value="interests" />
        <Tab label="Bevakningar" value="subscriptions" />
        {/* <Tab label="Avslutade annonser" value="inactive" /> */}
      </Tabs>
    </ThemeProvider>
  );
}
